import { IonButton, IonRow } from '@ionic/react'
import * as React from 'react'
import { useChatsData } from '../../../hooks/chats/useChatsData'
import { OverlayContainer } from '../StyledContainers'
import axios from '../../../utils/axios'

interface Props {
  onClose: () => void,
}

const LeaveGroup : React.FC<Props> = ({ onClose }) => {
  const { leaveRoom, setLoading, focusedRoom } = useChatsData()
  const handleSubmit = () => {
    onClose()
    setLoading(true)
    axios.put('/leave_group_chat', { room_id: focusedRoom.id })
      .then(({ data }) => {
        if (!data.ok) {
          reportError(data.message)
          setLoading(false)
          return
        }
        leaveRoom(focusedRoom)
      })
      .catch(() => {
        reportError('An unexpected error has ocurred.')
      })
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <OverlayContainer>
      <h4>Leave Group</h4>
      <p>Are you sure you wish to leave this group?</p>
      <IonRow className='ion-justify-content-end'>
        <IonButton onClick={onClose} style={{ '--background': '#8E151F', color: 'white' }}>Cancel</IonButton>
        <IonButton onClick={handleSubmit} style={{ '--background': '#326771', color: 'white' }}>Confirm</IonButton>
      </IonRow>
    </OverlayContainer>
  )
}
export default LeaveGroup
